<form [formGroup]="formData">
    <div class="filter p-1">
        <div >
            <div class="bodyCopy ml-4 text-left" *ngIf="selectedView"></div>                      
            <ul id="groupBySubmenu" class="projectView  p-0 mt-1">
                <span class="status text-right"><b>Status</b></span>
                <li class="groupOptions" *ngFor="let projectView of projectGridViews">
                    <div class="groupOptions" style="position:relative">
                        <label class="container_rd groupOptions">
                            <input type="radio" formControlName="status" value="{{projectView.name}}"
                                (click)="changeGridView(projectView)" >
                            <span class="checkmark_rd "></span>                      
                            <span class="bodyCopy ml-1">{{projectView.name}} </span>
                        </label>
                    </div>
                </li>
            </ul>
        </div>
        <div class="o_dropdown" *ngIf="organizations && this.userRole == 'SuperAdmin' && organizationFlag">
            <select class="form-control f_dropdown" formControlName="org" #org
                (change)="onChangeOrganization(org.value)">
                <option *ngFor="let organization of organizations" [value]="organization.id">{{organization.name}}
                </option>
            </select>
        </div>
    </div>
</form>